<template>
  <div class="wrapper">
    <!-- Modal imprimir etiqueta-->
    <b-modal id="modal-print" ref="modal-print" title="Imprimir Etiqueta" size="sm" class="modal-primary" hide-footer>
      <b-form @submit.prevent="printLabel">
        <b-form-group description label="Tipo Etiqueta">
          <b-form-select v-model="$v.typeLabel.$model" :state="$v.typeLabel.$dirty ? !$v.typeLabel.$error : null">
            <option value="">Seleccione</option>
            <option value="1">Etiqueta 10x15 normal</option>
            <option value="2">Etiqueta 10x15 specs abajo (solo total de cantidades)</option>
            <option value="3">Etiqueta 10x15 (solo total de kilos netos)</option>
            <option value="4">Etiqueta 10x15 tipo 2</option>
            <option value="5">Etiqueta 10x15 V(UN)</option>
            <option value="6">Etiqueta 10x15 H</option>
          </b-form-select>
        </b-form-group>

        <b-form-group description label="Pallet">
          <v-select label="name" :filterable="false" :options="options" v-model="selected" @search="onSearch">
            <template slot="no-options"> escribe para buscar pallets </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">{{ option.number }} - {{ option.container }}</div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">{{ option.number }} - {{ option.container }}</div>
            </template>
          </v-select>
        </b-form-group>

        <b-form-group>
          <label>Numero de etiquetas a imprimir</label>

          <b-form-input
            type="text"
            :state="$v.numberLabel.$dirty ? !$v.numberLabel.$error : null"
            v-model="$v.numberLabel.$model"
            placeholder=""
          >
          </b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Imprimir</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import miniToastr from "mini-toastr";
import { PrintPallet } from "../../assets/js/printFunctions.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

Vue.use(miniToastr);

import { required, numeric, minLength, between } from "vuelidate/lib/validators";
import * as _ from "lodash";

export default {
  name: "printContent",
  components: {
    vSelect
  },
  created() {},
  data() {
    return {
      data: 0,
      selected: null,
      modalShown: false,
      numberLabel: 0,
      typeLabel: "",
      contentPrint: "",
      options: []
    };
  },
  validations: {
    selected: { required },
    numberLabel: {
      required,
      numeric
    },
    typeLabel: { required }
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _.debounce((loading, search, vm) => {
      vm.$axios
        .get(`/api/v1/pallet/all_pallets/?q=${escape(search)}`)
        .then((res) => {
          vm.options = res.data;
          loading(false);
        })
        .catch((error) => {
          console.log(error.response);
        });
    }, 350),
    printLabel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // miniToastr.info("Campos requeridos o inválidos en el formulario.", "");
      } else {
        this.$axios("/api/v1/pallet/" + this.selected.id + "/pallet_print/")
          .then((res) => {
            PrintPallet(res.data, this.numberLabel, this.typeLabel);
          })
          .catch((error) => {
            console.log(error);
          });
        this.$refs["modal-print"].hide();
      }
    }
  },
  mounted() {}
};
</script>
<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  /*display: inline-block;*/
  /*width: 100%;*/
  min-height: calc(1.5em + 0.75rem + 2px);
  /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
  font-size: 0.6875rem;
  font-weight: 400;
  /*line-height: 1.5;*/
  color: #5c6873;
  /*vertical-align: middle;*/
  /*background-color: #fff;*/
  border: 1px solid #e4e7ea;
  /*border-radius: 0.25rem;*/
  /*-webkit-appearance: none;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}

.style-chooser img {
  height: auto;
  max-width: 2.5rem;
  margin-right: 1rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
</style>
